@if (loading()) {
  <div class="templates-loading">
    <i class="fa-solid fa-spinner fa-spin"></i>
  </div>
} @else {
  <div class="templates-grid">
    @for (t of templates(); track t.id) {
    <div class="tpl-card">
      <div class="tpl-card-header">
        <div class="tpl-icon" [class]="'tpl-icon-' + t.category.toLowerCase()">
          <i class="fa-regular fa-file-lines"></i>
        </div>
        <span class="tpl-name">{{ t.name }}</span>
        <span class="tpl-category" [class]="'cat-' + t.category.toLowerCase()">{{ categoryLabel(t.category) }}</span>
      </div>

      <div class="tpl-preview">
        <div class="tpl-preview-header">
          <div class="tpl-preview-icon"><i class="fa-solid fa-bell"></i></div>
          <span class="tpl-preview-app">Yaldi · now</span>
        </div>
        <p class="tpl-preview-title" [pTooltip]="t.title" tooltipPosition="top">{{ t.title }}</p>
        <p class="tpl-preview-body" [pTooltip]="t.body" tooltipPosition="top">{{ t.body }}</p>
      </div>

      <div class="tpl-card-footer">
        <button class="tpl-edit-btn" (click)="openEdit(t)">
          <i class="fa-regular fa-pen-to-square"></i>
          <span>Edit</span>
        </button>
        <button class="tpl-delete-btn" (click)="askDelete(t)">
          <img src="assets/icons/delete.svg" alt="delete" />
        </button>
      </div>
    </div>
    }

    @empty {
    <div class="templates-empty">No templates found.</div>
    }
  </div>
}

<app-add-template-form
  [editTemplate]="selectedTemplate"
  [(visibility)]="editDialogVisible"
  (saved)="loadTemplates()" />

<app-add-template-form
  [(visibility)]="addDialogVisible"
  (created)="loadTemplates()" />

<!-- Delete confirm dialog -->
<p-dialog
  header="Delete Template"
  [(visible)]="confirmDeleteVisible"
  [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  styleClass="tpl-confirm-dialog"
  (onHide)="deletingTemplate = null">
  @if (deletingTemplate) {
    <p class="tpl-confirm-text">
      Are you sure you want to delete <strong>{{ deletingTemplate.name }}</strong>? This cannot be undone.
    </p>
  }
  <ng-template pTemplate="footer">
    <button class="tpl-cancel-btn" (click)="cancelDelete()">Cancel</button>
    <button class="tpl-delete-confirm-btn" (click)="confirmDelete()" [disabled]="deleteLoading()">
      @if (deleteLoading()) { <i class="fa-solid fa-spinner fa-spin"></i> Deleting… }
      @else { <i class="fa-solid fa-trash"></i> Delete }
    </button>
  </ng-template>
</p-dialog>
